export default __webpack_public_path__ + "static/media/group-578.36583dc8.png";